import { render, staticRenderFns } from "./StudentView.vue?vue&type=template&id=088dfd90"
import script from "./StudentView.vue?vue&type=script&lang=js"
export * from "./StudentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports